import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}]]

const IconCircle = createReactComponent('outline', 'circle', 'Circle', __iconNode);

export default IconCircle;